import { TicketCreation } from '../containers/TicketCreation';
import { usePortalData } from '../data/usePortalData';
import { useFormData } from '../data/useFormData';
import { useNavigationContext } from '../hooks/useNavigationContext';
import { useConfirmModal } from '../hooks/useConfirmModal';
import { ModalPanel } from 'foundations-components/transitional/components/ModalPanel';
import { PanelSection } from 'foundations-components/transitional/components/Panel';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import { Text } from 'foundations-components/components/Text';
import I18n from 'I18n';
import { useEffect } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function TicketCreationPanel() {
  var _portalData$settings$, _portalData$settings;
  const {
    toListings
  } = useNavigationContext();
  const {
    data: portalData,
    loading: portalLoading
  } = usePortalData();
  const {
    data: formData,
    loading: formLoading
  } = useFormData();
  const title = (_portalData$settings$ = portalData === null || portalData === void 0 || (_portalData$settings = portalData.settings) === null || _portalData$settings === void 0 ? void 0 : _portalData$settings.formHeaderText) !== null && _portalData$settings$ !== void 0 ? _portalData$settings$ : '';
  const hasForm = !!(formData !== null && formData !== void 0 && formData.formGuid);
  const {
    isOpen: isConfirmingClose,
    openConfirmModal,
    confirmModalProps
  } = useConfirmModal({
    onConfirm: toListings
  });
  useEffect(() => {
    if (!portalLoading && !formLoading && (!hasForm || !portalData)) {
      toListings();
    }
  }, [portalLoading, formLoading, hasForm, portalData, toListings]);
  if (!hasForm || !portalData) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(ModalPanel, {
      width: 560,
      paddingInline: "600",
      onEsc: openConfirmModal,
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: openConfirmModal,
        "aria-label": I18n.text('customer-portal-app.ticketListings.ticketCreationCloseButton'),
        color: "icon-core-default"
      }), /*#__PURE__*/_jsx(Text, {
        as: "h4",
        typography: "heading-500",
        color: "text-core-default",
        paddingBlock: "600",
        paddingInline: "600",
        children: title
      }), /*#__PURE__*/_jsx(PanelSection, {
        padding: "0",
        flush: true,
        children: /*#__PURE__*/_jsx(TicketCreation, {
          onSuccess: toListings,
          formData: formData,
          portalData: portalData
        })
      })]
    }), isConfirmingClose && /*#__PURE__*/_jsx(ConfirmModal, Object.assign({
      message: I18n.text('customer-portal-app.ticketListings.ticketCreationDiscardConfirmMessage'),
      description: I18n.text('customer-portal-app.ticketListings.ticketCreationDiscardConfirmDescription'),
      confirmLabel: I18n.text('customer-portal-app.ticketListings.ticketCreationDiscardConfirmButton'),
      rejectLabel: I18n.text('customer-portal-app.ticketListings.ticketCreationDiscardCancelButton'),
      size: "auto"
    }, confirmModalProps))]
  });
}